// @ constants
const actionTypes = require('constants/actionTypes');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;

// @actions
const notification = require('actions/notifications');

const reset = () => ({
    type: actionTypes.OPEN_YOUNG_PERSONAL_DATA_RESET,
});

const validateStep = () => ({
    type: actionTypes.OPEN_YOUNG_PERSONAL_DATA_VALIDATE_STEP,
});

const validateDataField = (fieldName, isOYPack) => ({
    type: actionTypes.OPEN_YOUNG_PERSONAL_DATA_VALIDATE_FIELD,
    payload: {
        fieldName,
        isOYPack
    }
});

const setField = (fieldName, value) => ({
    type: actionTypes.OPEN_YOUNG_PERSONAL_DATA_SET_FIELD,
    payload: {
        fieldName,
        value
    }
});

const validateDocumentOpenyoungRequest = () => ({
    type: actionTypes.OPEN_YOUNG_PERSONAL_DATA_VALIDATE_DOCUMENT_REQUEST,
});

const validateDocumentOpenyoungSuccess = (data, isOYPack) => ({
    type: actionTypes.OPEN_YOUNG_PERSONAL_DATA_VALIDATE_DOCUMENT_SUCCESS,
    payload: {
        data,
        isOYPack
    }
});

const validateDocumentOpenyoungFailure = (error) => ({
    type: actionTypes.OPEN_YOUNG_PERSONAL_DATA_VALIDATE_DOCUMENT_FAILURE,
    payload: {
        error
    }
});

const validateDocumentOpenyoung = (isOYPack) => (dispatch, getState) => {
    const immPersonalData = getState().openYoungPersonalData;
    const params = {
        header: {
            version: 1
        },
        query: {
            childNifNumber: immPersonalData.getIn(['documentNumber', 'value']),
        }
    };

    dispatch(validateDocumentOpenyoungRequest());
    return APIPost({
        dispatch,
        endpoint: 'openYoungGetJuniorProductData',
        params
    })
        .then(response => {
            dispatch(validateDocumentOpenyoungSuccess(response, isOYPack));
        })
        .catch(response => {
            if (!!response.error) {
                const OYPackNotificationMessage = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_OYPackNotificationMessage');
                const OYCardNotificationMessage = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_OYCardNotificationMessage');
                const toastMsg = isOYPack ? OYPackNotificationMessage : OYCardNotificationMessage;
                dispatch(validateDocumentOpenyoungFailure(response.error));
                dispatch(notification.error({ message: toastMsg }));
            } else {
                throw response;
            }
        });
};

const validateField = (fieldName, validateDocument, isOYPack, fieldValue) => (dispatch) => {
    dispatch(validateDataField(fieldName, isOYPack));
    if (validateDocument && fieldValue) {
        dispatch(validateDocumentOpenyoung(isOYPack));
    }
};

const fillOpenYoungPersonalData = (immOpenYoungProfile) => ({
    type: actionTypes.OPEN_YOUNG_PERSONAL_DATA_FILL,
    payload: {
        immOpenYoungProfile,
    }
});

module.exports = {
    fillOpenYoungPersonalData,
    reset,
    setField,
    validateField,
    validateStep,
};
